module.exports = __webpack_public_path__ + "img/small-arrow-right.467d9c34.svg";